import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../common/actions';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import ObsolescenceParametersTable from './obsolescenceParametersTable';
import ObsolescencePageHeader from './obsolescencePageHeader';

class ObsolescenceParameters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'obsParams': [{}],
      'saveButtonDisabled': true,
    };
    this.disableSaveButton = this.disableSaveButton.bind(this);
    this.setObsParams = this.setObsParams.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ObsolescenceParameters, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchObsolescenceParameters();
  }

  setObsParams(obsParamsValues) {
    this.setState({'obsParams': obsParamsValues});
  }

  handleSaveClick() {
    const {obsParams} = this.state;
    this.props.saveObsParameters(obsParams);
  }

  disableSaveButton(status) {
    this.setState({'saveButtonDisabled': status});
  }

  render() {
    const {saveButtonDisabled} = this.state;
    const {list, loadingStatus} = this.props;
    return (
      <div>
        <ObsolescencePageHeader saveButtonDisabled={saveButtonDisabled} handleSaveClick={this.handleSaveClick}/>
        <ObsolescenceParametersTable obsParamList={list} loading={loadingStatus}
          disableSaveButton={this.disableSaveButton} setObsParams={this.setObsParams}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'list': state.obsolescenceParameters.list,
    'loadingStatus': state.obsolescenceParameters.loadingStatus,
    'permissions': state.session.permissions,
  };
};

const {fetchObsolescenceParameters, saveObsParameters, navigateTo} = Actions;

export default connect(mapStateToProps, {
  fetchObsolescenceParameters,
  saveObsParameters,
  navigateTo,
})(ObsolescenceParameters);
